import React from 'react';
import { useTranslation } from 'react-i18next';
import SocialMediaLinks from '../UI/SocialMediaLinks';

const Footer = ({ systemSettings, darkMode }) => {
  const { t } = useTranslation();

  // Use system settings or fallback to translations
  const footerText = systemSettings?.branding?.footerText || t('footer.company');
  const copyright = systemSettings?.branding?.copyright || t('footer.copyright');
  const locations = systemSettings?.branding?.locations || t('footer.locations');
  
  // Get custom styling from CMS settings
  const footerBackgroundColor = systemSettings?.branding?.footerBackgroundColor || 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(200, 200, 200, 0.5))';
  const footerTextColor = systemSettings?.branding?.footerTextColor || '#1f2937';
  const footerTransparency = systemSettings?.branding?.footerTransparency || 95;
  
  // Convert hex color to rgba with transparency
  const hexToRgba = (hex, alpha) => {
    if (hex.startsWith('linear-gradient') || hex.startsWith('radial-gradient')) {
      return hex; // Return gradient as-is
    }
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha / 100})`;
  };

  // In dark mode, override admin colors with dark theme
  const footerStyle = darkMode ? {
    backgroundColor: 'rgba(17, 24, 39, 0.9)',
    color: '#ffffff',
    backdropFilter: 'blur(10px)',
    borderTop: '1px solid rgba(55, 65, 81, 0.5)'
  } : {
    background: footerBackgroundColor.startsWith('linear-gradient') || footerBackgroundColor.startsWith('radial-gradient') 
      ? footerBackgroundColor 
      : hexToRgba(footerBackgroundColor, footerTransparency),
    color: footerTextColor,
    backdropFilter: 'blur(10px)',
    borderTop: footerBackgroundColor.startsWith('linear-gradient') || footerBackgroundColor.startsWith('radial-gradient')
      ? '1px solid rgba(59, 130, 246, 0.3)'
      : `1px solid ${hexToRgba(footerBackgroundColor, 30)}`
  };

  return (
    <footer 
      className="mt-auto py-1 px-2 sm:px-4"
      style={footerStyle}
    >
      <div className="max-w-7xl mx-auto">
        {/* Mobile and Tablet: Show only copyright */}
        <div className="block lg:hidden text-center">
          <p className="text-xs opacity-70" style={{ color: darkMode ? '#ffffff' : footerTextColor }}>
            {copyright}
          </p>
        </div>
        
        {/* Desktop: Show full footer */}
        <div className="hidden lg:flex justify-between items-center space-y-1 sm:space-y-0">
          {/* Company Info */}
          <div className="text-left">
            <p className="font-medium text-xs" style={{ color: darkMode ? '#ffffff' : footerTextColor }}>
              {footerText}
            </p>
            <p className="text-xs opacity-70" style={{ color: darkMode ? '#ffffff' : footerTextColor }}>
              {locations}
            </p>
          </div>
          
          {/* Social Media Links */}
          <div className="flex items-center space-x-1">
            <SocialMediaLinks 
              socialMediaLinks={systemSettings?.branding?.socialMediaLinks} 
              darkMode={darkMode} 
            />
          </div>
          
          {/* Copyright */}
          <div className="text-right">
            <p className="text-xs opacity-70" style={{ color: darkMode ? '#ffffff' : footerTextColor }}>
              {copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
